import { useState } from 'react';
import { linkMembers, unlink, getSupersetForExercise } from '../lib/sessionSupersets';

/**
 * Hook CONDIVISO per creare/sciogliere superserie di sessione durante l'esecuzione
 * (scheda + allenamento libero). Non tocca DB/log/statistiche: opera solo sul
 * modello di sessione `sessionSupersets`.
 *
 * @param sessionSupersets stato corrente (può essere null in WorkoutExecution)
 * @param setSessionSupersets setter (accetta updater funzionale)
 * @param orderedIds id degli esercizi nell'ORDINE reale della lista a schermo
 *        (PB-008: i membri del gruppo seguono la lista, non l'ordine dei tap)
 */
export function useSupersetLinking({ sessionSupersets, setSessionSupersets, orderedIds }) {
  const [linkMode, setLinkMode] = useState(false);
  const [selection, setSelection] = useState([]); // id esercizi selezionati (2+)

  const enter = () => { setSelection([]); setLinkMode(true); };
  const cancel = () => { setSelection([]); setLinkMode(false); };

  const toggle = (id) => {
    setSelection(prev =>
      prev.includes(id)
        ? prev.filter(x => x !== id)
        : [...prev, id] // PB-008: nessun cap — superserie da 2, 3, 4+ esercizi
    );
  };

  const confirm = () => {
    if (selection.length < 2) return;
    // PB-008: membri sempre nell'ordine reale della lista, non dei tap.
    // Difensivo: id non presenti in orderedIds vanno in coda (ordine di tap).
    const pos = (id) => {
      const i = (orderedIds || []).indexOf(id);
      return i === -1 ? Number.MAX_SAFE_INTEGER : i;
    };
    const ordered = [...selection].sort((x, y) => pos(x) - pos(y));
    // PB-011 (J4): la superserie live NON deriva più il recupero dagli esercizi.
    // Nasce SENZA recupero (null) → nessun timer a fine giro finché non viene
    // impostato esplicitamente "Recupero tra i giri". Nessun default 90.
    setSessionSupersets(prev => linkMembers(prev || [], ordered, null, () => `ss-${ordered.join('-')}`));
    cancel();
  };

  const dissolve = (groupId) => {
    setSessionSupersets(prev => unlink(prev || [], groupId));
  };

  // PB-011: imposta il "Recupero tra i giri" di una superserie di SESSIONE.
  // Vale solo per la sessione corrente (persistito in localStorage con la
  // sessione); nessuna scrittura su DB. Vuoto/null → nessun recupero; 0 →
  // nessun recupero esplicito. Nessun default 90.
  const setGroupRest = (groupId, seconds) => {
    let value = null;
    if (seconds !== '' && seconds != null) {
      const n = parseInt(seconds, 10);
      value = Number.isFinite(n) && n >= 0 ? n : null;
    }
    setSessionSupersets(prev => (prev || []).map(g =>
      g.id === groupId ? { ...g, restSeconds: value } : g
    ));
  };

  const isSelected = (id) => selection.includes(id);
  const isInSuperset = (id) => !!getSupersetForExercise(sessionSupersets, id);

  return { linkMode, selection, enter, cancel, toggle, confirm, dissolve, setGroupRest, isSelected, isInSuperset };
}
